import React from "react";
import { useDispatch } from "react-redux";
import { MalwareFindingComponentProps } from "@sscs/types";
import { Button, Card } from "@sscs/ui";
import { PERMISSION } from "Constants";
import { useAllowedTo, useAppDispatch } from "Hooks";
import { openMoveToProject, openShareReport } from "../../store/dialogs.slice";

function MalwareFindingActionFileStream(): React.JSX.Element {
  const dispatch = useDispatch();
  const canMoveToProject = useAllowedTo({
    permissions: [PERMISSION.UPLOAD_VERSION],
  });

  if (!canMoveToProject)
    return (
      <span>
        {" "}
        The ReversingLabs analyst team is available 24/7 to confirm malware
        findings. Please ask a member of your organization with the appropriate
        role to move this software package to a project before contacting
        ReversingLabs Support.
      </span>
    );

  return (
    <>
      <span>
        {" "}
        The ReversingLabs analyst team is available 24/7 to confirm malware
        findings. Please{" "}
      </span>
      <Button
        variant="text"
        isInline
        onClick={() => dispatch(openMoveToProject())}
      >
        move this software package to a project
      </Button>{" "}
      <span>before sharing it with ReversingLabs Support.</span>
    </>
  );
}

function MalwareFindingActionProject(): React.JSX.Element {
  const dispatch = useAppDispatch();
  const canGenerateReportLink = useAllowedTo({
    permissions: [PERMISSION.SHARE_REPORT],
  });

  if (!canGenerateReportLink)
    return (
      <span>
        {" "}
        The ReversingLabs analyst team is available 24/7 to confirm malware
        findings. You don’t have permissions to share a report. Contact your
        organization administrator to adjust your permissions, allowing you to
        share the report with ReversingLabs Support.
      </span>
    );

  return (
    <>
      <span> Please, </span>
      <Button
        variant="text"
        isInline
        onClick={() => dispatch(openShareReport({ contactSupport: true }))}
      >
        contact our support
      </Button>
      <span>
        , the ReversingLabs analyst team is available 24/7 to confirm malware
        findings.
      </span>
    </>
  );
}

type MalwareFindingProps = MalwareFindingComponentProps & {
  isFileStream: boolean;
};

const MalwareFinding = ({
  isAnalystVetted,
  isFileStream,
}: MalwareFindingProps): React.JSX.Element => {
  if (isAnalystVetted) {
    return (
      <Card.Card>
        <Card.Title>Finding confirmed</Card.Title>
        <Card.Content>
          <span>
            This malware detection has been reviewed and confirmed by
            ReversingLabs analysts. Due to the presence of malicious code, this
            software package should be rejected. If this software has already
            been deployed by the organization, an incident response process
            should be initiated.
          </span>
        </Card.Content>
      </Card.Card>
    );
  }

  return (
    <Card.Card>
      <Card.Title>Assistance available</Card.Title>
      <Card.Content>
        <span>
          This malware finding has not yet been reviewed by ReversingLabs
          analysts. All malware detections should be treated as true positives
          until proven otherwise.
        </span>
        {isFileStream ? (
          <MalwareFindingActionFileStream />
        ) : (
          <MalwareFindingActionProject />
        )}
      </Card.Content>
    </Card.Card>
  );
};

export default MalwareFinding;
